import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Close from '../assets/img/close.svg';
import { admessageActions } from '../actions';
import { showToast } from '../services';
import { useLoggedUser } from '../hooks/useLoggedUser';

const initialState = {
    InformationLine1: '',
    InformationLine2: '',
    InformationLine3: '',
    InformationLine4: '',
    submitted: false,
    showAdMessageModal: false,
    showResponse: false
};

const AdMessage = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [state, setState] = useState(initialState);
    const [adMessage, setAdMessage] = useState(null);
    const loggedUser = useLoggedUser();
    const showModalTimeoutRef = useRef(null);
    const hideModalTimeoutRef = useRef(null);

    if (!loggedUser?.data?.StudentProfileID) {
        history.replace('/login');
        return null;
    }

    useEffect(() => {
        if (loggedUser && !adMessage && !localStorage.getItem('adMessageDisplayed')) {
            dispatch(admessageActions.fetchAdMessage())
                .then((response) => {
                    const adData = response?.data;
                    const isEmpty = !adData || Object.keys(adData).length === 0;
                    if (!isEmpty) {
                        setAdMessage(adData);
                        const toMilliseconds = (min) => min * 60 * 1000;
                        if (showModalTimeoutRef.current) window.clearTimeout(showModalTimeoutRef.current);
                        showModalTimeoutRef.current = window.setTimeout(() => showModal(), toMilliseconds(adData.PopUpTime));
                    }
                })
                .catch((error) => {
                    console.error('Error::', error);
                });
        }

        return () => {
            if (showModalTimeoutRef.current) {
                window.clearTimeout(showModalTimeoutRef.current);
                showModalTimeoutRef.current = null;
            }
        };
    }, [dispatch, adMessage]);

    useEffect(() => {
        return () => {
            if (hideModalTimeoutRef.current) {
                window.clearTimeout(hideModalTimeoutRef.current);
                hideModalTimeoutRef.current = null;
            }
        };
    }, []);

    const showModal = () => {
        setState(prevState => ({ ...prevState, showAdMessageModal: true }));
    };

    const hideModal = () => {
        setState(prevState => ({ ...prevState, showAdMessageModal: false }));
        // Mark the ad message as displayed in localStorage to ensure it doesn't appear again
        localStorage.setItem('adMessageDisplayed', 'true');
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = () => {
        setState(prevState => ({ ...prevState, submitted: true }));

        dispatch(admessageActions.submitAdmessage({
            StudentProfileID: loggedUser.data.StudentProfileID,
            InformationLine1: state.InformationLine1,
            InformationLine2: state.InformationLine2,
            InformationLine3: state.InformationLine3,
            InformationLine4: state.InformationLine4
        }))
            .then((response) => {
                if (response && response.ok === true) {
                    setState(prevState => ({ ...prevState, showResponse: true }));
                    if (hideModalTimeoutRef.current) window.clearTimeout(hideModalTimeoutRef.current);
                    hideModalTimeoutRef.current = window.setTimeout(() => {
                        hideModalTimeoutRef.current = null;
                        hideModal();
                        setState(prevState => ({ ...prevState, showResponse: false }));
                    }, 3000);
                }
            })
            .catch((error) => {
                console.error('Error: ', error);
            });
    };

    const { showAdMessageModal, InformationLine1, InformationLine2, InformationLine3, InformationLine4, submitted, showResponse } = state;

    return (
        <React.Fragment>
            {/* Modal starts here */}
            <Modal className='navbar-modal ad-modal-m modal-dialog-centered' id="navbar-modal" animation={false} show={showAdMessageModal} onHide={hideModal}>
                <div className="modal-dialog modal-dialog-centered m-1">
                    <div className="ad-md-content" style={{ border: 'none' }}>
                        <div className="modal-body ad-modal-body">
                            <div className="modal-header">
                                {showResponse && adMessage?.AdResponseMessage && (
                                    <p className="md-h-title response-message">{adMessage.AdResponseMessage}</p>
                                )}
                                <button type="button" className="close-btn float-right" onClick={hideModal}>
                                    <span className='close-text' aria-hidden="true">
                                        <img className="w-10" src={Close} alt="Close" />
                                    </span>
                                </button>
                            </div>
                            <div className="w-100 mt-4 d-flex align-items-center flex-column justify-content-center">
                                <h4 className="up-avatar-title">~ Winner !!! ~</h4>
                                <label className='black-font mt-3'>{adMessage && adMessage.MessageText}</label>
                            </div>
                            <div className='conatiner ad-md-cont w-60 d-flex justify-content-center m-auto pl-2 mt-2'>
                                <div className='row w-100 d-flex align-items-center justify-content-center mt-3'>
                                    <div className='col-md-6 col-sm-4 col-lg-6'>
                                        <div className='d-flex flex-column'>
                                            <label className="from-label b-font" htmlFor="InformationLine1">{adMessage && adMessage.AdCaptureinformationLine1}</label>
                                            <input
                                                type="text"
                                                name="InformationLine1"
                                                className='mt-2'
                                                value={InformationLine1}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className='d-flex flex-column mt-3'>
                                            <label className="from-label b-font" htmlFor="InformationLine2">{adMessage && adMessage.AdCaptureinformationLine2}</label>
                                            <input
                                                type="text"
                                                name="InformationLine2"
                                                className='mt-2'
                                                value={InformationLine2}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-sm-4 col-lg-6'>
                                        <div className='d-flex flex-column'>
                                            <label className="from-label b-font" htmlFor="InformationLine3">{adMessage && adMessage.AdCaptureinformationLine3}</label>
                                            <input
                                                type="text"
                                                name="InformationLine3"
                                                className='mt-2'
                                                value={InformationLine3}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className='d-flex flex-column mt-3'>
                                            <label className="from-label b-font" htmlFor="InformationLine4">{adMessage && adMessage.AdCaptureinformationLine4}</label>
                                            <input
                                                type="text"
                                                name="InformationLine4"
                                                className='mt-2'
                                                value={InformationLine4}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="u-a-modal-f mt-5 mb-2">
                                <button className="accept-btn mt-1" onClick={handleSubmit} disabled={submitted}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
};

export default AdMessage;